const decimalNumberRegex = /^\d*\.?\d*$/;
const numberRegex = /^\d+$/;
const passwordRegex = /^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*]).{8,}$/;

export { decimalNumberRegex, numberRegex, passwordRegex };
